import React from "react";
import SVGInline from "react-svg-inline";

/* eslint import/no-webpack-loader-syntax: off */
import svg from "!raw-loader!../../images/icons/profileb-icon.svg";

export default ({ height = "24px", pointer = true, onClick }) => (
  <SVGInline
    height={height}
    svg={svg}
    onClick={onClick ? onClick : () => {}}
    className={pointer ? "pointer" : ""}
  />
);



// WEBPACK FOOTER //
// ./src/components/icons/ProfileBoldIcon.js